"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsRecord = void 0;
const class_validator_1 = require("class-validator");
function isType(ctor, value) {
    return value.constructor === ctor || value instanceof ctor;
}
function isValidRecord(value) {
    return (value != null
        && typeof value === "object"
        && value.constructor === Object);
}
/**
 * Check if a given value is a `Record<TKey, TValue>`.
 */
function IsRecord(keyType, valueType, validationOptions) {
    return function (object, propertyName) {
        (0, class_validator_1.registerDecorator)({
            name: "isRecord",
            target: object.constructor,
            propertyName: propertyName,
            constraints: [keyType, valueType],
            options: validationOptions,
            validator: {
                validate(value, args) {
                    return (isValidRecord(value)
                        && Object.entries(value).every(([k, v]) => isType(keyType, k) && isType(valueType, v)));
                },
            },
        });
    };
}
exports.IsRecord = IsRecord;
//# sourceMappingURL=IsRecord.js.map